import SystemLayer from '../../system-metadata/FeatureClass.js';
import CustomerLayer from '../../customer-metadata/UserLayer.js';
import FeatureCollection from '../../geodata/FeatureCollection.js';
import FeatureReference from '../FeatureReference.js';
import FeatureReferenceSourceType from '../FeatureReferenceSourceType.js';
import FeatureReferenceQueryPatternType from '../FeatureReferenceQueryPatternType.js';
import FeatureRecord from '../FeatureRecord.js';
import LayerReference from '../LayerReference.js';
/**
 * @memberof feature-references
 * @property {feature-references.FeatureReference} [constrainBy]
 * @property {feature-references.LayerReference} layer
 */
class SpatialQueryParameters {
    constructor(props) {
        this.layer = props.layer && new LayerReference(props.layer);
        this.constrainBy = props.constrainBy && new FeatureReference(props.constrainBy);
    }
    loadForm() {
        const Layer = LAYER_RECORD_MAP[this.layer.type];
        const load = [Layer.retrieve(this.layer.sourceId)];
        if (this.constrainBy) {
            load.push(FeatureCollection.fromFeatureReferences([this.constrainBy]));
        }
        return Promise.all(load).then(([layer, constrainBy]) => {
            return {
                layer: layer.toLayerRecord(),
                constrainBy: FeatureRecord.fromGeoJSON(constrainBy.features[0]),
            };
        });
    }
    /**
     * Query for features constrained by the defined feature; may inherit the
     * constraining feature if not defined.
     *
     * @return {Promise.<FeatureCollection>}
     */
    evaluate() {
        return (this.constrainBy
            ? FeatureCollection.fromFeatureReferenceAndLayer(this.constrainBy, this.layer)
            : FeatureCollection.fromUserLayer(this.layer));
    }
}
SpatialQueryParameters.PATTERN_TYPE = FeatureReferenceQueryPatternType.SPATIAL_QUERY;
const LAYER_RECORD_MAP = {
    [FeatureReferenceSourceType.CUSTOMER]: CustomerLayer,
    [FeatureReferenceSourceType.SYSTEM]: SystemLayer,
};
export default SpatialQueryParameters;
